import React, { Component } from 'react';

import { SectionTitle }  from '../../helpers/section';
import { isMobile } from 'react-device-detect';

class Contact extends Component {
    render() {
        return (
            <section className={isMobile ? 'home-contact-mobile' : 'home-contact'} id="contact">
                <div className="container box-shadow">
                    {SectionTitle({section: 'FORMULÁRIO DE CONTATO', subtitle:'FALE', featured: 'CONOSCO'})}
                    <div className="row">                    
                        <div className="col-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label htmlFor="name">Nome:</label>
                                <input type="text" name="name" id="name" className="form-control" placeholder="" />                                
                            </div>
                        </div>
                        <div className="col-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label htmlFor="name">E-mail:</label>
                                <input type="email" name="email" id="email" className="form-control" placeholder="" />                                
                            </div>
                        </div>
                        <div className="col-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label htmlFor="name">Telefone:/Celular:</label>
                                <input type="phone" name="phone" id="phone" className="form-control" placeholder="" />                                
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                              <label htmlFor="">Mensagem:</label>
                              <textarea className="form-control" name="mensagem" id="mensagem" rows="5"></textarea>
                            </div>                            
                        </div>
                        <div className="col-12">
                            <div className="d-flex justify-content-center">
                                <button type="submit" className="btn btn-blue"><i className="fa fa-send" /> ENVIAR CONTATO</button>
                            </div>
                        </div>
                    </div>                 
                </div>
            </section>
        )
    }
}

export default Contact;
